function qsa(selector, scope) {
   return (scope || document).querySelectorAll(selector);
}

function qs(selector, scope) {
    return (scope || document).querySelector(selector);
}

function addClass(target, className) {
    if (!target) return;
    const classList = className.split(' ');
    classList.forEach(classText => {
      target.classList.add(classText);
    });
  }

function removeClass(target, className) {
    if (!target) return;
    const classList = className.split(' ');
    classList.forEach(classText => {
      target.classList.remove(classText);
    });
}

function forEach(list, cb) {
    for (let index = 0, len = list.length; index < len; index += 1) {
      cb(list[index], index);
    }
  }

// addEventListener wrapper:
function $on(target, type, callback, parameter = {}) {
    if (target) {
    target.addEventListener(type, callback, parameter);
    }
}

function closest(el, selector) {
    let matchesFn;
  
    // find vendor prefix
    [
      'matches',
      'webkitMatchesSelector',
      'mozMatchesSelector',
      'msMatchesSelector',
      'oMatchesSelector',
    ].some(fn => {
      if (typeof document.body[fn] === 'function') {
        matchesFn = fn;
        return true;
      }
      return false;
    });
  
    let parent;
  
    // traverse parents
    while (el) {
      parent = el.parentElement;
      if (parent && parent[matchesFn](selector)) {
        return parent;
      }
      // eslint-disable-next-line no-param-reassign
      el = parent;
    }
  
    return null;
  }

function hasClass(target, className) {
    return target.classList.contains(className);
}

const getClosetSectionHeaderLegacy = targetEle => {
    const titleSuffix = '[class*="-title"]';
    const hTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    const extraTags = ['div', 'a'];
    const title = qs(
      `${[...hTags, ...extraTags].join(`${titleSuffix},`) +
        titleSuffix},.${hTags.join(',.')},${hTags.join(',')}`,
      targetEle,
    );
  
    if (!title) return getClosetSectionHeaderLegacy(targetEle.parentNode);
    const rex = /(<([^>]+)>)/gi;
    return title.innerText.replace(rex, '').trim();
  };

const getLinkType = url => {
    if (!url) return undefined;
    const INTERNAL = 'internal';
    const EXTERNAL = 'external';
    if (url[0] === '#' || url[0] === '/') return INTERNAL;
    return new URL(url).origin !== window.location.origin ? EXTERNAL : INTERNAL;
  };
  
  // Please DON'T use this function if the module can be hardcode
const getModule = function n({ parentNode }) {
    if (parentNode) {
      if (
        parentNode.nodeName === 'SECTION' ||
        (parentNode.dataset && parentNode.dataset.script)
      ) {
        return parentNode;
      }
      return n(parentNode);
    }
    return undefined;
  };

  /**
 * Vertical scroll to a certain position of the page
 * @param  {Number} toPosition position to be scrolled
 * @param  {Number} duration   duration in milliseconds of the scroll
 * @return {void}
 */
function scrollTo(toPosition, duration) {
    // some browsers use body and others use documentElement to
    // scroll the page so we use both implementations
    const scrollPos = Math.max(
      document.documentElement.scrollTop,
      document.body.scrollTop,
    );
  
    if (duration <= 0) return;
    const difference = toPosition - scrollPos;
    const perTick = (difference / duration) * 10;
  
    setTimeout(() => {
      document.documentElement.scrollTop = scrollPos + perTick;
      document.body.scrollTop = scrollPos + perTick;
      // if the scroll is equal to the final position break the recursive function
      if (scrollPos + perTick === toPosition) return;
  
      scrollTo(toPosition, duration - 10);
    }, 10);
  }
  